import styled from "styled-components";
import { space } from "styled-system";

export const LanguageWrap = styled.div`
    ${space}
`;
